import React, { FC } from 'react';
import { isFunction } from 'lodash';
import { rem } from 'polished';
import styled from 'styled-components';

import type { Step } from 'components/OnboardingForm/OnboardingSteps';

import { useProgressNavContext } from './ProgressNav';

interface SubItemProps {
  isActive?: boolean;
  isComplete?: boolean;
}

const SubItemStyled = styled.div<SubItemProps>`
  position: relative;
  margin-left: ${rem(30)};
  padding-left: ${rem(20)};
  transition: 0.3s color ease;

  ${({ isActive, isComplete, theme }) => (isActive || isComplete) && `color: ${theme.colors.main}`};

  &::before {
    content: '';
    position: absolute;
    top: ${rem(6)};
    left: 0;
    display: inline-block;
    padding: ${rem(3)};
    border: solid ${({ theme }) => theme.colors.main};
    border-width: 0 1px 1px 0;
    opacity: 0;
    transform: translateY(-1px) rotate(-45deg);
    transition: 0.3s opacity ease;

    ${({ isActive }) => isActive && 'opacity: 1;'};
  }

  &:not(:last-child) {
    margin-bottom: ${rem(21)};
  }
`;

interface RenderProps {
  isActive: boolean;
  isComplete: boolean;
}

export interface Props {
  step: Step;
  children: React.ReactNode | ((renderProps: RenderProps) => React.ReactNode);
}

const ProgressSubNavItem: FC<Props> = ({ children, step }) => {
  const { activeStep } = useProgressNavContext();
  const isActive = step === activeStep;
  const isComplete = activeStep != null && activeStep > step;

  return (
    <SubItemStyled isActive={isActive} isComplete={isComplete}>
      {isFunction(children) ? children({ isActive, isComplete }) : children}
    </SubItemStyled>
  );
};

export default ProgressSubNavItem;
